import React from 'react';
import { useDeleteServiceableUrlMutation, useFetchServiceableUrlsForClusterQuery } from './service';
import LoaderCard from '../shared/LoaderCard';
import { Card } from 'antd';
import ServiceableUrlsTable from './table/ServiceableUrlsTable';
import useAddUrlAnalysisProcessWithNotification from '../process/hooks/useAddUrlAnalysisProcessWithNotification';
import useBatchUrlAnalysisProcessesPolling from '../process/hooks/useBatchUrlAnalysisProcessesPolling';
import { SERVICEABLE_URLS_POLLING_TIME_MS } from '../settings';
import ScoreIndicator from '../shared/ScoreIndicator';
import { useFetchUrlClustersQuery } from '../urlClusters/service';
import AddUrlsInClusterButton from './AddUrlsInClusterButton';


type Props = {
    websiteGuid: string;
    clusterGuid: string;
};

export default function ClusterUrls({ websiteGuid, clusterGuid }: Props) {
    const { isRunningBatchAnalysis } = useBatchUrlAnalysisProcessesPolling(websiteGuid);
    const { data: urlClusters, isLoading: isLoadingUrlClusters } = useFetchUrlClustersQuery({ w_guid: websiteGuid });
    const { data: clusterUrls, isLoading: isLoadingUrls } = useFetchServiceableUrlsForClusterQuery(
        {
            w_guid: websiteGuid,
            cluster_guid: clusterGuid,
        }, // If we are running an analysis, refetch if the data is old
        { refetchOnMountOrArgChange: isRunningBatchAnalysis ? SERVICEABLE_URLS_POLLING_TIME_MS / 1000 : false }
    );
    const [deleteServiceableUrl, { isLoading: isDeletingUrl }] = useDeleteServiceableUrlMutation();

    const { addUrlAnalysisProcess, isAddingUrlAnalysisProcess } = useAddUrlAnalysisProcessWithNotification();

    const handleCheckUrlClick = (urlGuid: string) => {
        addUrlAnalysisProcess(websiteGuid, urlGuid);
    };

    const handleDeleteUrlClick = (urlGuid: string) => {
        deleteServiceableUrl({ w_guid: websiteGuid, url_guid: urlGuid });
    };

    // const averageSeoScore = useMemo(() => getAverageUrlSeoScore(clusterUrls || []), [clusterUrls]);
    const averageSeoScore = urlClusters?.find((c) => c.guid === clusterGuid)?.avg_seo_score || 0;
    const isLoading = isLoadingUrls || isLoadingUrlClusters;
    return (
        <>
            {isLoading && <LoaderCard />}
            {!isLoading && (
                <Card
                    title={
                        <div className="page-group-seo-score" style={{ display: "flex", gap: "12px" }}>
                            <span>Avg. SEO Score:</span>
                            <ScoreIndicator value={averageSeoScore} />
                        </div>
                    }
                    extra={<AddUrlsInClusterButton websiteGuid={websiteGuid} clusterGuid={clusterGuid} />}
                >
                    <ServiceableUrlsTable
                        serviceableUrls={clusterUrls || []}
                        urlClusters={urlClusters || []}
                        isCheckButtonLoading={isAddingUrlAnalysisProcess}
                        isDeleteButtonLoading={isDeletingUrl}
                        onCheck={handleCheckUrlClick}
                        onDelete={handleDeleteUrlClick}
                    />
                </Card>
            )}
        </>
    );
}
